module.exports = __webpack_public_path__ + "img/lalanitahome4v_1n.031845ea.webp";